import { MasterDataSearchOutput } from '../models';

export class MasterDataListLoad {
  public static readonly type = '[MasterDataList] Load';
  constructor(public payload: MasterDataSearchOutput) {}
}

export class MasterDataListInitialState {
  public static readonly type = '[MasterDataList] Set initial state';
}
